import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
// images
// NOTE: For now, let's just use this same stock image for all video pages.
import backgroundImageDesktop from '../../../../../images/components/sectionVideoPlayer/family-running-on-beach-desktop.webp';
import backgroundImageTablet from '../../../../../images/components/sectionVideoPlayer/family-running-on-beach-tablet.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const largeDown = theme.largeDown();
  const [isLargeDown, setIsLargeDown] = useState(largeDown);

  useEffect(() => {
    if (largeDown !== isLargeDown) {
      setIsLargeDown(largeDown);
    }
  }, [largeDown, isLargeDown]);

  return (
    <SectionVideoPlayer
      backgroundImage={isLargeDown ? backgroundImageTablet : backgroundImageDesktop}
      config={config}
      playButtonSupportiveText='Watch the video to learn about NM Keep Dreaming'
      duration='1 min'
      durationDisplay='1 min' // round to nearest minute from duration
      sectionId='nm-keep-dreaming'
      videoId='5sc1JRF2v7g'
      videoTitle='Keep Dreaming Video'
      title='Keep Dreaming'
    />
  );
};
